import type { PublicSlotKey } from '#packages/apilib';
import type { PreviewerApi } from './previewerApi';

export const PreviewerApiKey: PublicSlotKey<PreviewerApi> = {
  name: 'PreviewerApi',
  public: true,
};
